var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5439 18.3077L5.28238 16.7L3.88623 16.3615L4.60546 13.4L11.5862 15.1769L17.8055 16.7L22.2901 17.8846C22.8401 18.0115 23.2632 18.4346 23.4324 18.9423C23.5593 19.45 23.3901 20 23.0093 20.3808C22.6285 20.7615 22.0785 20.8885 21.5708 20.8038L11.5439 18.3077ZM17.5516 8.74614C17.5516 10.1423 17.0439 11.4538 16.0708 12.4269C15.0978 13.4 13.7862 13.9923 12.3901 13.9923C10.9939 13.9923 9.68238 13.4 8.70931 12.4269C7.73623 11.4538 7.22854 10.1 7.22854 8.74614C7.27085 5.86922 12.3901 0.538452 12.3901 0.538452C12.3901 0.538452 17.5516 5.86922 17.5516 8.74614Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.634615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0564 10.1C15.0564 11.0731 14.5487 11.9615 13.7449 12.4692C12.8987 12.8923 11.9256 12.8923 11.0795 12.4692C10.2756 11.9615 9.76794 11.0731 9.76794 10.1C9.76794 8.66154 12.4333 6.75769 12.4333 6.75769C12.4333 6.75769 15.0564 8.66154 15.0564 10.1Z",
    fill: "white",
    stroke: "#FFCC09",
    strokeWidth: 0.634615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20931 20.7616C2.70161 20.8885 2.15161 20.7616 1.72854 20.3808C1.34777 20.0001 1.22084 19.4501 1.34777 18.9001C1.517 18.3501 1.94007 17.927 2.49007 17.8424L6.97469 16.7001L13.1939 15.177L20.217 13.4424L20.8939 16.4039L19.4978 16.7424L13.2362 18.3078L3.20931 20.7616Z",
    fill: "white",
    stroke: "#CCCCCC",
    strokeWidth: 0.634615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.af030f362fdf6813ef94836856b88949.svg";
export { ForwardRef as ReactComponent };